import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { CartDrawer } from '../shared/CartDrawer';
import { SalePopup } from '../shared/SalePopup';

export const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <CartDrawer />
      <SalePopup />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};
